import { useState } from "react";
import { IInOfficeEvent } from "../../types/formAssignments/IInOfficeEvent";
import PatientListPage from "./patientListPage/patientListPage";
import PatientInfoAndFormsPage from "./patientInfoAndFormsPage/PatientInfoAndFormsPage";

export type FormAssignmentsPage = "patientList" | "assignForms";

const FormAssignmentsWrapper = () => {
  const [selectedEvent, setSelectedEvent] = useState<IInOfficeEvent | null>(
    null
  );

  const [page, setPage] = useState<FormAssignmentsPage>("patientList");

  return (
    <>
      {page === "patientList" && (
        <PatientListPage
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          setPage={setPage}
        />
      )}
      {selectedEvent && page === "assignForms" && (
        <PatientInfoAndFormsPage
          initialEvent={selectedEvent}
          setPage={setPage}
        />
      )}
    </>
  );
};

export default FormAssignmentsWrapper;
